/** Public, bounded city projection. GeoNames identifiers remain stable across catalog refreshes. */
export interface HomeCity {
  id: number;
  name: string;
  region: string;
  countryCode: string;
  country: string;
  timeZone: string;
}

export const cityLabel = (city: HomeCity): string =>
  [...new Set([city.name, city.region, city.country].filter(Boolean))].join(', ');
